import React from "react";
import { Card } from "react-bootstrap";
import { allPlanCodes, ENTERPRISE } from "statics/planCodes";
import { MdCheck } from "react-icons/md";

import "./PlanCard.scss";

interface Plan {
  id: string;
  label: string;
  range: { min: number; max: number };
  price?: number;
}

interface PlanLabels {
  sizeLabel: string;
  infoLabel: string;
  setupFeeLabel: string | null;
  noteLabel: string | null;
}

interface PlanCardProps {
  planCode?: string;
}

function buildLabels(plan: Plan): PlanLabels {
  let sizeLabel: string;
  let setupFeeLabel: string | null;
  let noteLabel: string | null;

  const infoLabel = plan.label;

  if (plan.id === ENTERPRISE) {
    sizeLabel = "100+";
    setupFeeLabel = null;
    noteLabel = null;
  } else {
    const { min, max } = plan.range;
    sizeLabel = `${min}-${max}`;
    setupFeeLabel = `$${plan.price} one-time setup fee`;
    noteLabel = "That's all you pay. Period.";
  }

  return {
    sizeLabel,
    infoLabel,
    setupFeeLabel,
    noteLabel,
  };
}

const PlanCard = ({ planCode }: PlanCardProps) => {
  const matchingPlan = allPlanCodes[planCode as keyof typeof allPlanCodes] as
    | Plan
    | undefined;

  if (!matchingPlan) return null;

  const { sizeLabel, setupFeeLabel, noteLabel, infoLabel } = buildLabels(
    matchingPlan!
  );

  const checkIcon = <MdCheck color="1d99a9" size={16} />;
  const pricingLabel = (
    <>
      <span className="price-amount">{sizeLabel}</span>
      <span className="price-frequency"> / employees</span>
    </>
  );

  return (
    <Card className="sales-quote-card">
      <div className="sales-quote-header">
        <p className="sales-quote-card-title">{infoLabel}</p>
        <p>{pricingLabel}</p>
      </div>

      <div className="pricing-details">
        {setupFeeLabel && (
          <div className="detail-item">
            {checkIcon}
            <span className="detail-text">{setupFeeLabel}</span>
          </div>
        )}
        {noteLabel && (
          <div className="detail-item">
            {checkIcon}
            <span className="detail-text">{noteLabel}</span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default PlanCard;
